import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useMic } from "../context/MicContext";
import {
  KeyRound,
  FileText,
  ShieldCheck,
  HelpCircle,
  LogOut,
  ChevronRight,
  Mic,
  MicOff,
} from "lucide-react";

export default function Altro() {
  const { logout } = useAuth();
  const mic = useMic();
  const navigate = useNavigate();

  const items = [
    { icon: KeyRound, label: "Modifica password", onClick: () => {} },
    { icon: FileText, label: "Termini e condizioni", onClick: () => {} },
    { icon: ShieldCheck, label: "Privacy e sicurezza", onClick: () => {} },
    { icon: HelpCircle, label: "Domande frequenti (F.A.Q.)", onClick: () => {} },
    {
      icon: LogOut,
      label: "Esci",
      danger: true,
      onClick: () => {
        logout();
        navigate("/login", { replace: true });
      },
    },
  ];

  const micOn = mic.permission === "granted";

  return (
    <div className="px-4 pt-6 pb-36">
      <h1 className="text-white text-[26px] font-semibold tracking-tight">
        Impostazioni
      </h1>
      <p className="text-white/60 text-sm mt-1">
        Gestisci il tuo account e le preferenze
      </p>

      {/* Microphone */}
      <div className="mt-5 rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="flex items-start gap-3">
          <div
            className={`w-10 h-10 rounded-xl flex items-center justify-center ${
              micOn
                ? "bg-[#14c2a1]/20 border border-[#14c2a1]/30 text-[#14c2a1]"
                : "bg-white/10 border border-white/15 text-white/70"
            }`}
          >
            {micOn ? <Mic size={16} /> : <MicOff size={16} />}
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between gap-3">
              <div>
                <div className="text-white text-[15px] font-medium">
                  Microfono notturno
                </div>
                <div className="text-white/60 text-[12px] mt-0.5">
                  {micOn
                    ? "Rilevamento tosse, russare e suoni notturni attivo"
                    : mic.permission === "denied"
                    ? "Permesso negato dal browser"
                    : "Non attivo"}
                </div>
              </div>
              <button
                onClick={async () => {
                  if (micOn) mic.reset();
                  else await mic.request();
                }}
                className={`relative w-12 h-7 rounded-full transition-colors flex-shrink-0 ${
                  micOn ? "bg-[#14c2a1]" : "bg-white/15"
                }`}
                aria-label="toggle microfono"
              >
                <span
                  className="absolute top-0.5 left-0.5 w-6 h-6 rounded-full bg-white shadow-md transition-transform"
                  style={{
                    transform: micOn ? "translateX(20px)" : "translateX(0)",
                  }}
                />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4 rounded-2xl overflow-hidden border border-white/10 bg-white/5 divide-y divide-white/5">
        {items.map((it) => {
          const I = it.icon;
          return (
            <button
              key={it.label}
              onClick={it.onClick}
              className={`w-full flex items-center justify-between px-4 py-4 text-left transition-colors hover:bg-white/10 ${
                it.danger ? "text-rose-300" : "text-white"
              }`}
            >
              <div className="flex items-center gap-3">
                <div
                  className={`w-9 h-9 rounded-xl flex items-center justify-center ${
                    it.danger
                      ? "bg-rose-500/15 border border-rose-400/30 text-rose-300"
                      : "bg-[#00a88a]/20 border border-[#00a88a]/30 text-[#14c2a1]"
                  }`}
                >
                  <I size={16} />
                </div>
                <span className="text-[15px] font-medium">{it.label}</span>
              </div>
              <ChevronRight size={16} className="text-white/40" />
            </button>
          );
        })}
      </div>

      <div className="mt-6 text-center text-white/40 text-xs">
        SmartDream v2.4.1 · Materassi &amp; Materassi
      </div>
    </div>
  );
}
